import React, { useEffect, useState } from "react";
import SpinnerTimeLoader from "../shared/timeLoading";
import AdvertismentStepper from "./advetisement-stepper";
import AdvertismentNumber from "./advertisement-number";
import AdvertismentOtp from "./advertisement-otp";
import Helpers from "../../helpers/shared.helper";

export default function AdvetisementIndex(props) {
  const [stepDetails] = useState({
    step1: {
      status: "inProgress",
    },
    step2: {
      status: "notVisited",
    },
    step3: {
      status: "notVisited",
    },
  });

  useEffect(() => {}, []); // eslint-disable-line react-hooks/exhaustive-deps


  const renderAdView = () => {
    let content = "";
    switch (props.flow) {
      case "number":
        content = <AdvertismentNumber
          history={props.history}
        />
        break;
      case "otp":
        content = <AdvertismentOtp
          history={props.history}
        />
        break;
      default:
        break;
    }
    return content;
  }

  return (
    <div>
      {false ? (
        <SpinnerTimeLoader />
      ) : (
        <div className="storefront-two-col-pg">
            {renderAdView()}
          {!Helpers.isMobile() && <AdvertismentStepper stepDetails={stepDetails} />}
        </div>
      )}
    </div>
  );
}
